<template>
  <div>
    <Form
      ref="permissionInfoForm"
      :model="formData"
      label-position="left"
      :label-width="120"
      :rules="formRules"
    >
      <FormItem
        v-for="item in permissionOption"
        :key="item.id"
        :label="item.label"
        :prop="item.id"
      >
        <RadioGroup v-model="formData[item.id]">
          <Radio :label="1">可编辑</Radio>
          <Radio :label="2">只读</Radio>
          <Radio :label="3">隐藏</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { nodeTypeMap } from './config';
export default {
  name: 'permissionInfo',
  computed: {
    ...mapState('workflow', ['permissionOption'])
  },
  props: ['formOpAuthList', 'dataConfig'],
  data() {
    return {
      formData: {},
      formRules: {}
    };
  },
  methods: {
    getFormOpAuthListData() {
      const formDataKeys = Object.keys(this.formData);
      const data = [];
      formDataKeys.forEach(key => {
        const formItemLabel = (
          this.permissionOption.find(item => item.id == key) || {}
        ).label;
        const obj = {
          formItemKey: key,
          formOpAuthType: this.formData[key],
          formItemLabel
        };
        data.push(obj);
      });
      return data;
    },
    init() {
      const { nodeType } = this.dataConfig;
      const { defaultPermissionVal } = nodeTypeMap[nodeType];
      console.log('this.nodeConfig', this.dataConfig);
      if (Array.isArray(this.permissionOption)) {
        const obj = {};
        this.permissionOption.forEach(item => {
          const { id } = item;
          const value = Array.isArray(this.formOpAuthList)
            ? (this.formOpAuthList.find(i => i.formItemKey == id) || {})
                .formOpAuthType
            : defaultPermissionVal;
          obj[id] = value || defaultPermissionVal;
        });
        this.formData = obj;
      }
    }
  },
  created() {
    this.init();
  }
  // watch: {
  //   formOpAuthList(val) {
  //     if (Array.isArray(val)) {
  //       const obj = {};
  //       val.forEach(item => {
  //         const { formItemKey, formOpAuthType } = item;
  //         obj[formItemKey] = formOpAuthType;
  //       });
  //       this.formData = obj;
  //     }
  //   }
  // }
};
</script>
